/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlarmAverage = createReactComponent("outline", "alarm-average", "IconAlarmAverage", [["path", { "d": "M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0", "key": "svg-0" }], ["path", { "d": "M7 4l-2.75 2", "key": "svg-1" }], ["path", { "d": "M17 4l2.75 2", "key": "svg-2" }], ["path", { "d": "M8 13h1l2 3l2 -6l2 3h1", "key": "svg-3" }]]);

export { IconAlarmAverage as default };
//# sourceMappingURL=IconAlarmAverage.mjs.map
